var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{staticClass:"input-style text-right",attrs:{"autocomplete":"off","placeholder":"Trung","size":_vm.size,"value":_vm.value},on:{"change":function($event){return _vm.onInputChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }